/* =========================================================================
   Floating buttons and the sticky add-to-cart bar: each one shows only while
   the button it mirrors is off screen, so the same call to action is always
   reachable but never visible twice.
   ========================================================================= */
(function () {
  const SELECTOR = ".float-btn, .sticky-atc";
  let watched = [];
  let wired = false;

  /* Shopify's theme preview bar is pinned to the bottom of the page on top of
     everything else, which hides a bottom-anchored button or bar on phones.
     Lift them over it whenever it is there. */
  const liftOverPreviewBar = () => {
    const bar = document.querySelector("#preview-bar-iframe, .shopify-preview-bar, #admin-bar-iframe");
    const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--float-offset", h ? h + "px" : "0px");
  };

  let frame = 0;
  const update = () => {
    frame = 0;
    watched.forEach(({ btn, anchor }) => {
      if (!btn.isConnected) return;
      const r = anchor.getBoundingClientRect();
      /* anchor hidden (display:none at this breakpoint) counts as off screen */
      const hidden = r.width === 0 && r.height === 0;
      const onScreen = !hidden && r.bottom > 8 && r.top < innerHeight - 8;
      btn.classList.toggle("is-visible", !onScreen);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };

  function init() {
    /* a section re-rendered in the theme editor leaves its moved button behind */
    [...document.body.querySelectorAll(":scope > .float-btn, :scope > .sticky-atc")].forEach((btn) => {
      const sel = btn.dataset.floatAnchor;
      if (sel && !document.querySelector(sel)) btn.remove();
    });

    watched = [];
    [...document.querySelectorAll(SELECTOR)].forEach((btn) => {
      /* position: fixed is relative to any transformed or filtered ancestor, so
         move the element out to <body>, where it can only ever track the viewport */
      if (btn.parentElement !== document.body) document.body.appendChild(btn);
      const anchor = btn.dataset.floatAnchor ? document.querySelector(btn.dataset.floatAnchor) : null;
      /* no twin on this page: this is the only copy, so always keep it up */
      if (!anchor) { btn.classList.add("is-visible"); return; }
      watched.push({ btn, anchor });
    });

    liftOverPreviewBar();
    update();

    if (wired) return;
    wired = true;
    addEventListener("scroll", schedule, { passive: true });
    addEventListener("resize", () => { liftOverPreviewBar(); schedule(); });
    addEventListener("load", () => { liftOverPreviewBar(); schedule(); });
    /* a background tab stops painting, so rAF never runs: catch up on return */
    addEventListener("visibilitychange", update);
    addEventListener("pageshow", update);
    setTimeout(liftOverPreviewBar, 1500); /* the preview bar is injected after load */
  }

  if (document.readyState === "loading") addEventListener("DOMContentLoaded", init);
  else init();
  addEventListener("shopify:section:load", init); /* theme editor re-renders sections */
})();
